<template>
    <div class="mt-0 mb-2 ml-3">
        <v-tabs v-model="tab" hide-slider>
            <v-tabs-slider color="success"></v-tabs-slider>
            <v-tab
                href="#doe"
                v-bind:class="{
                    'selected-tab': tab == 'doe',
                }"
                >DOE</v-tab
            >
            <v-tab
                href="#match"
                v-bind:class="{
                    'selected-tab': tab == 'match',
                }"
                >Match To</v-tab
            >
        </v-tabs>

        <v-tabs-items v-model="tab" class="mt-3">
            <v-tab-item value="doe">
                <div style="overflow-y: auto; height: 500px">
                    <div
                        class="layout row mb-2"
                        v-for="prop in getRowProperties(row)"
                    >
                        <div class="font-weight-medium mr-1 width-200">
                            {{ prop.name }}:
                        </div>
                        <div>{{ prop.value }}</div>
                    </div>

                    <div class="layout row mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Registered On:
                        </div>
                        <div>{{ row.datE_REG | date }}</div>
                    </div>
                    <div class=" mb-2">
                        <div
                            class="font-weight-medium mr-1"
                            style="text-decoration: underline;"
                        >
                            Vote History:
                        </div>
                        <div v-for="history in getVoteHistory(row.voteHistory)">
                            <v-layout row>
                                <div class="width-150" v-if="history.date">
                                    {{ history.date | date }}
                                </div>
                                <div>{{ history.election }}</div>
                            </v-layout>
                        </div>
                    </div>
                </div>
            </v-tab-item>
            <v-tab-item value="match">
                <div style="overflow-y: auto; height: 500px">
                    <div v-if="match" class="mt-2">
                        <div
                            class="layout row mb-2"
                            v-for="prop in getMatchProperties(match)"
                        >
                            <div class="font-weight-medium mr-1 width-200">
                                {{ prop.name }}:
                            </div>
                            <div>{{ prop.value }}</div>
                        </div>
                        <div class="layout row mb-2" v-if="row.dob">
                            <div class="font-weight-medium mr-1 width-200">
                                Date Of Birth:
                            </div>
                            <div>{{ row.dob | date }}</div>
                        </div>
                        <div class="layout row mb-2" v-if="row.dob">
                            <div class="font-weight-medium mr-1 width-200">
                                DLV:
                            </div>
                            <div>{{ row.dlv | date }}</div>
                        </div>
                    </div>
                    <div class="title mt-0" v-else>
                        No Match
                    </div>
                </div>
            </v-tab-item>
        </v-tabs-items>

        <!-- <v-layout row>
            <v-flex xs6>
                <div
                    class="title mt-2 mb-4 pb-2 layout row"
                    style="text-decoration: underline;"
                >
                    DOE
                </div>

                <div
                    class="layout row mb-2"
                    v-for="prop in getRowProperties(row)"
                >
                    <div class="font-weight-medium mr-1 width-200">
                        {{ prop.name }}:
                    </div>
                    <div>{{ prop.value }}</div>
                </div>

                <div class="layout row mb-2">
                    <div class="font-weight-medium mr-1 width-200">
                        Registered On:
                    </div>
                    <div>{{ row.datE_REG | date }}</div>
                </div>
                <div class=" mb-2">
                    <div
                        class="font-weight-medium mr-1"
                        style="text-decoration: underline;"
                    >
                        Vote History:
                    </div>
                    <div v-for="history in getVoteHistory(row.voteHistory)">
                        <v-layout row>
                            <div class="width-150" v-if="history.date">
                                {{ history.date | date }}
                            </div>
                            <div>{{ history.election }}</div>
                        </v-layout>
                    </div>
                </div>
            </v-flex>
            <v-flex xs6>
                <div v-if="match" class="mt-2">
                    <div
                        class="title mt-2 mb-4 pb-2 layout row"
                        style="text-decoration: underline;"
                    >
                        Match To
                    </div>

                    <div
                        class="layout row mb-2"
                        v-for="prop in getMatchProperties(match)"
                    >
                        <div class="font-weight-medium mr-1 width-200">
                            {{ prop.name }}:
                        </div>
                        <div>{{ prop.value }}</div>
                    </div>
                    <div class="layout row mb-2" v-if="row.dob">
                        <div class="font-weight-medium mr-1 width-200">
                            Date Of Birth:
                        </div>
                        <div>{{ row.dob | date }}</div>
                    </div>
                    <div class="layout row mb-2" v-if="row.dob">
                        <div class="font-weight-medium mr-1 width-200">
                            DLV:
                        </div>
                        <div>{{ row.dlv | date }}</div>
                    </div>
                </div>
                <div class="title mt-0" v-else>
                    No Match
                </div>
            </v-flex>
        </v-layout> -->
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, sum } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
    },
    data() {
        return {
            match: "",
            tab: "doe",
        };
    },
    watch: {
        row(newValue, oldValue) {
            this.loadMatch();
        },
    },
    async created() {
        this.loadMatch();
    },
    computed: {},
    methods: {
        async loadMatch() {
            if (!this.row.matchID) return;

            const response = await this.$http.get(
                "api/voting/getMatch?id=" + this.row.matchID
            );

            this.match = response;
        },
        getRowProperties(data) {
            return Object.keys(
                except(
                    data,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "datE_REG",
                    "dob",
                    "dlv",
                    "id",
                    "reG_ID",
                    "matched",
                    "matchedTo",
                    "matchName",
                    "matchID",
                    "verified",
                    "regID",
                    "matchType",
                    "isMatched",
                    "voteHistory"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: data[key],
                    };
                })
                .filter((p) => p.value || p.name == "Apt");
        },
        getMatchProperties(data) {
            return Object.keys(
                except(
                    data,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "datE_REG",
                    "dob",
                    "dlv",
                    "id",
                    "reG_ID",
                    "party",
                    "election",
                    "congress",
                    "senate",
                    "assembly",
                    "council",
                    "doeID"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: data[key],
                    };
                })
                .filter((p) => p.value || p.name == "Apt");
        },
        getVoteHistory(data) {
            if (!data) return;

            return data.split(";").map((line) => {
                const date = line.split(" ")[0];
                const election = line.split(" ")[1];

                return {
                    date: moment(date).isValid() ? date : "",
                    election: moment(date).isValid() ? election : line,
                };
            });
        },
    },
};
</script>
<style>
.selected-tab {
    color: rgb(76, 175, 80) !important;
    border-bottom: 1px solid rgb(76, 175, 80) !important;
}
</style>
